import React from "react";

const TransfersImg = ({ color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2941 8.53668V13.6867C19.2941 16.7667 17.5341 18.0867 14.8941 18.0867H6.10409C5.65409 18.0867 5.2241 18.0467 4.8241 17.9567C4.5741 17.9167 4.3341 17.8467 4.1141 17.7667C2.6141 17.2067 1.7041 15.9067 1.7041 13.6867V8.53668C1.7041 5.45668 3.46409 4.13672 6.10409 4.13672H14.8941C17.1341 4.13672 18.7441 5.08671 19.1741 7.25671C19.2441 7.65671 19.2941 8.06668 19.2941 8.53668Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2952 11.5368V16.6868C22.2952 19.7668 20.5352 21.0868 17.8952 21.0868H9.1052C8.3652 21.0868 7.69521 20.9868 7.11521 20.7668C5.92521 20.3268 5.1152 19.4168 4.8252 17.9568C5.2252 18.0468 5.6552 18.0868 6.1052 18.0868H14.8952C17.5352 18.0868 19.2952 16.7668 19.2952 13.6868V8.5368C19.2952 8.0668 19.2552 7.64684 19.1752 7.25684C21.0752 7.65684 22.2952 8.99681 22.2952 11.5368Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4925 13.7566C11.9505 13.7566 13.1325 12.5746 13.1325 11.1166C13.1325 9.65855 11.9505 8.47656 10.4925 8.47656C9.03452 8.47656 7.85254 9.65855 7.85254 11.1166C7.85254 12.5746 9.03452 13.7566 10.4925 13.7566Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.77441 8.91699V13.317"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2158 8.91699V13.317"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TransfersImg;
